import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "maplibre-gl/dist/maplibre-gl.css";
import "maplibre-gl";
import "@maplibre/maplibre-gl-leaflet";

const OPENFREEMAP_STYLE = "https://tiles.openfreemap.org/styles/liberty";

/** Lớp điểm quan tâm có sẵn của nền (cửa hàng, khách sạn, quán…) — ẩn để chỉ còn địa điểm do mình ghim. */
const POI_SOURCE_LAYERS = new Set(["poi", "aerodrome_label"]);

function hideBasemapPois(mlMap) {
  try {
    const layers = mlMap.getStyle()?.layers || [];
    layers.forEach((ly) => {
      if (POI_SOURCE_LAYERS.has(ly["source-layer"]) && mlMap.getLayoutProperty(ly.id, "visibility") !== "none") {
        mlMap.setLayoutProperty(ly.id, "visibility", "none");
      }
    });
  } catch {
    /* style chưa sẵn sàng */
  }
}

/**
 * Nền bản đồ vector miễn phí của OpenFreeMap, vẽ bằng MapLibre bên trong Leaflet.
 * `hidePois` (mặc định bật): ẩn biểu tượng + tên địa điểm của nền, chỉ giữ đường, tên đường, sông hồ…
 */
export default function OpenFreeMapLayer({ style = OPENFREEMAP_STYLE, hidePois = true }) {
  const map = useMap();

  useEffect(() => {
    const layer = L.maplibreGL({
      style,
      attribution:
        '<a href="https://openfreemap.org" target="_blank" rel="noopener noreferrer">OpenFreeMap</a> ' +
        '© <a href="https://www.openmaptiles.org/" target="_blank" rel="noopener noreferrer">OpenMapTiles</a> ' +
        'Data from <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a>',
    }).addTo(map);

    let mlMap = null;
    const onStyle = () => hideBasemapPois(mlMap);
    // Map MapLibre chỉ được tạo khi lớp thực sự gắn vào bản đồ (onAdd) — có thể chậm hơn lúc gọi addTo
    const setup = () => {
      try {
        mlMap = layer.getMaplibreMap();
        if (!mlMap) return;
        if (mlMap.isStyleLoaded()) onStyle();
        mlMap.on("styledata", onStyle);
      } catch {
        /* ignore */
      }
    };
    if (hidePois) {
      if (layer.getMaplibreMap?.()) setup();
      else layer.once("add", setup);
    }

    return () => {
      try {
        layer.off("add", setup);
        mlMap?.off("styledata", onStyle);
      } catch {
        /* ignore */
      }
      try {
        map.removeLayer(layer);
      } catch {
        /* map đã bị huỷ */
      }
    };
  }, [map, style, hidePois]);

  return null;
}
